import { useState, useCallback, useEffect, useRef } from 'react';
import { api } from '@/lib/api';
import type { FiardleStatsResponse } from '@/lib/api';

export function useFiardleStats(userId?: string) {
  const fetchIdRef = useRef(0);
  const [stats, setStats] = useState<FiardleStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = useCallback(async () => {
    const id = ++fetchIdRef.current;
    setLoading(true);
    setError(null);

    try {
      const result = await api.getFiardleStats(userId);
      if (fetchIdRef.current !== id) return;
      setStats(result);
    } catch (err) {
      if (fetchIdRef.current !== id) return;
      setError(err instanceof Error ? err.message : 'Failed to fetch stats');
    } finally {
      if (fetchIdRef.current === id) {
        setLoading(false);
      }
    }
  }, [userId]);

  useEffect(() => {
    fetchStats();
    return () => {
      fetchIdRef.current++;
    };
  }, [fetchStats]);

  return { stats, loading, error, refetch: fetchStats };
}
